import decode from 'jwt-decode';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setMsgAsync, Message } from './notificationsSlice';

export const startApplicationAsync = createAsyncThunk(
  'applications/startApplication',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/sessions/start', value);
      return response.data;
    } catch (e) {
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const restartApplicationAsync = createAsyncThunk(
  'applications/restartApplication',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/sessions/restart', value);
      return response.data;
    } catch (e) {
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const stopApplicationAsync = createAsyncThunk(
  'applications/stopApplication',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/sessions/stop', value);
      return response.data;
    } catch (e) {
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const getApplicationsAsync = createAsyncThunk(
  'applications/getApplications',
  async (value, { dispatch }) => {
    try {
      const response = await axios.get('/api/v1/applications');
      return response.data;
    } catch (e) {
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const getSessionsAsync = createAsyncThunk(
  'applications/getSessions',
  async () => {
    try {
      const response = await axios.get('/api/v1/sessions');
      return response.data;
    } catch (e) {
      return null;
    }
  },
);

const initialState = {
  loading: {
    start: false,
    restart: false,
    appTimeout: false,
  },
  applications: [],
  sessions: [],
  currentSessionId: null,
};

export const applicationsSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    setCurrentSessionId: (state, action) => {
      state.currentSessionId = action.payload;
      state.loading.appTimeout = false;
    },
    setAppTimeoutLoading: (state, action) => {
      state.loading.appTimeout = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startApplicationAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.start = false;
          return;
        }
        state.sessions = action.payload;
        state.loading.start = false;
      })
      .addCase(startApplicationAsync.pending, (state, action) => {
        state.loading.start = true;
      })
      .addCase(restartApplicationAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.restart = false;
          return;
        }
        state.sessions = action.payload;
        state.loading.restart = false;
      })
      .addCase(restartApplicationAsync.pending, (state, action) => {
        state.loading.restart = true;
      })
      .addCase(getApplicationsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.applications = action.payload;
      })
      .addCase(getSessionsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.sessions = action.payload;
      })
      .addCase(stopApplicationAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.start = false;
          return;
        }
        state.sessions = action.payload;
        state.loading.start = false;
      })
      .addCase(stopApplicationAsync.pending, (state, action) => {
        state.loading.start = true;
      });
  },
});

export const getApplications = (state) => state.applications.applications;
export const getSessions = (state) => state.applications.sessions;
export const getCurrentSessionId = (state) =>
  state.applications.currentSessionId;
export const getLoading = (state) =>
  state.applications.loading.start || state.applications.loading.restart;
export const getLoadingStart = (state) => state.applications.loading.start;
export const getLoadingRestart = (state) => state.applications.loading.restart;
export const getLoadingAppTimeout = (state) =>
  state.applications.loading.appTimeout;

export const { setCurrentSessionId, setLoading, setAppTimeoutLoading } =
  applicationsSlice.actions;

export default applicationsSlice.reducer;
